import React from 'react';
import { DatePicker, Space, Button } from 'antd';
import type { RangePickerProps } from 'antd/es/date-picker';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-tw';
import locale from 'antd/es/date-picker/locale/zh_TW';
import { nowTpe } from '../utils/datetime';

const { RangePicker } = DatePicker;

interface DateRangePickerProps {
  onChange: (dates: [string, string] | null) => void;
  value?: [string, string] | null;
}

const DateRangePicker: React.FC<DateRangePickerProps> = ({ onChange, value }) => {
  // 轉換日期字符串為dayjs對象
  const dateValue = value
    ? [dayjs(value[0]), value[1] ? dayjs(value[1]) : null]
    : null;

  // 日期範圍變化處理
  const handleDateRangeChange: RangePickerProps['onChange'] = (dates, dateStrings) => {
    if (dates) {
      onChange([dateStrings[0], dateStrings[1]]);
    } else {
      onChange(null);
    }
  };

  // 設置預定義時間範圍（以台灣時區的今天為基準）
  const handlePresetRange = (days: number) => {
    const endDate = nowTpe();
    const startDate = endDate.subtract(days, 'day');
    onChange([startDate.format('YYYY-MM-DD'), endDate.format('YYYY-MM-DD')]);
  };

  // 範圍預設（以台灣時區的今天為基準）
  const presets: { label: string; value: [dayjs.Dayjs, dayjs.Dayjs] }[] = [
    { label: '過去7天', value: [nowTpe().subtract(7, 'd'), nowTpe()] },
    { label: '過去30天', value: [nowTpe().subtract(30, 'd'), nowTpe()] },
    { label: '過去90天', value: [nowTpe().subtract(90, 'd'), nowTpe()] },
    { label: '過去180天', value: [nowTpe().subtract(180, 'd'), nowTpe()] },
  ];

  return (
    <Space direction="vertical" size={12}>
      <Space>
        <RangePicker
          locale={locale}
          format="YYYY-MM-DD"
          value={dateValue as any}
          onChange={handleDateRangeChange}
          presets={presets}
          placeholder={['開始日期', '結束日期']}
          allowEmpty={[false, true]}
          style={{ width: '350px' }}
        />
        <Space>
          <Button onClick={() => handlePresetRange(7)}>週</Button>
          <Button onClick={() => handlePresetRange(30)}>月</Button>
          <Button onClick={() => handlePresetRange(90)}>季</Button>
          <Button onClick={() => handlePresetRange(180)}>半年</Button>
        </Space>
      </Space>
    </Space>
  );
};

export default DateRangePicker;
